import { TranspaletaElectricaForm } from './TranspaletaElectricaForm';
import { TranspaletaManualForm } from './TranspaletaManualForm';
import { CarretillaForm } from './CarretillaForm';
import { EquiposAlmacenForm } from './EquiposAlmacenForm';
import { ReservasForm } from './ReservasForm';
import { RoturasForm } from './RoturasForm';

// ── OPERARIO: ALMACÉN ────────────────────────────────────────────
export const AlmacenSection = ({
  almTab, setAlmTab, equipos, historial, archivo, guardar,
  te, setTE, tm, setTM, car, setCar, ea, setEA, reserva, setReserva, rotura, setRotura,
}) => (
  <div className="space-y-4">
    <div className="flex gap-2 bg-white rounded-xl p-2 shadow">
      {[["Transpaleta Eléctrica", "⚡ T. Eléctrica"], ["Transpaleta Manual", "🔧 T. Manual"], ["Carretilla", "🏗️ Carretilla"], ["Equipos Almacén", "🔌 Equipos"], ["Reservas", "📅 Reservas"], ["Roturas", "🔧 Roturas"]].map(([t, l]) => (
        <button key={t} onClick={() => setAlmTab(t)} className={`flex-1 py-2 rounded-lg text-xs font-bold transition-all ${almTab === t ? "bg-blue-600 text-white" : "text-gray-500 hover:bg-gray-100"}`}>{l}</button>
      ))}
    </div>
    {almTab === "Transpaleta Eléctrica" && (
      <TranspaletaElectricaForm te={te} setTE={setTE} equipos={equipos} guardar={guardar} />
    )}
    {almTab === "Transpaleta Manual" && (
      <TranspaletaManualForm tm={tm} setTM={setTM} equipos={equipos} guardar={guardar} />
    )}
    {almTab === "Carretilla" && (
      <CarretillaForm car={car} setCar={setCar} equipos={equipos} guardar={guardar} />
    )}
    {almTab === "Equipos Almacén" && (
      <EquiposAlmacenForm ea={ea} setEA={setEA} equipos={equipos} guardar={guardar} />
    )}
    {almTab === "Reservas" && (
      <ReservasForm reserva={reserva} setReserva={setReserva} equipos={equipos} historial={historial} archivo={archivo} guardar={guardar} />
    )}
    {almTab === "Roturas" && (
      <RoturasForm rotura={rotura} setRotura={setRotura} guardar={guardar} />
    )}
  </div>
);
